import api from '../utils/baseUrl';

class TransactionService {
    async getTransactions(filters: {
        transactionType?: string;
        status?: string;
        fromUsername?: string;
        toUsername?: string;
        sortColumn?: 'amount' | 'createdAt';
        sortDirection?: 'asc' | 'desc';
    } = {}) {
        try {
            const response = await api.get('/api/transactions', {params: filters});
            return response.data ?? {};
        } catch (error) {
            console.error('Error fetching transactions:', error);
            return [];
        }
    }
}

export default new TransactionService();